import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { PopoverService } from '../../../components/popover/popover.service';
import { ToolbarUserDropdownComponent } from './toolbar-user-dropdown/toolbar-user-dropdown.component';
import {AuthenticationService} from '../../../../app/shared/services/authentication.service';
import {User, UserService} from '../../../../@backend';
import {firstValueFrom} from 'rxjs';

@Component({
  selector: 'vex-toolbar-user',
  templateUrl: './toolbar-user.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ToolbarUserComponent implements OnInit {

  dropdownOpen: boolean;
  user?: User;

  constructor(private popover: PopoverService,
              private cd: ChangeDetectorRef,
              public authService: AuthenticationService,
              private userService: UserService) { }

  async ngOnInit(): Promise<void> {
    const userId = this.authService.currentUserValue?.id;
    if(!userId) return;

    try {
      this.user = await firstValueFrom(this.userService.userControllerGetPublicUser(userId));
      this.cd.markForCheck();
    } catch(error) {
      console.error('User avatar could not be loaded.', error);
    }
  }

  get userInitials(): string {
    const firstName = this.user?.firstname || this.authService.currentUserValue?.firstname || '';
    const lastName = this.user?.lastname || this.authService.currentUserValue?.lastname || '';
    return `${firstName.charAt(0)}${lastName.charAt(0)}`.toLocaleUpperCase() || '?';
  }

  showPopover(originRef: HTMLElement) {
    this.dropdownOpen = true;
    this.cd.markForCheck();

    const popoverRef = this.popover.open({
      content: ToolbarUserDropdownComponent,
      origin: originRef,
      data: this.user,
      offsetY: 12,
      position: [
        {
          originX: 'center',
          originY: 'top',
          overlayX: 'center',
          overlayY: 'bottom'
        },
        {
          originX: 'end',
          originY: 'bottom',
          overlayX: 'end',
          overlayY: 'top',
        },
      ]
    });

    popoverRef.afterClosed$.subscribe(() => {
      this.dropdownOpen = false;
      this.cd.markForCheck();
    });
  }
}
